import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("zfd_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Response interceptor — hard-kick on session revoked (single-active-device enforcement)
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err?.response?.data?.detail || "";
    if (err?.response?.status === 401 && typeof detail === "string" && detail.startsWith("session_revoked")) {
      // Fire-and-forget hard logout. Guard against double-fire during interceptor storms.
      if (!window.__zfd_session_revoked__) {
        window.__zfd_session_revoked__ = true;
        try {
          localStorage.removeItem("zfd_token");
          localStorage.removeItem("zfd_user");
        } catch (_e) { /* ignore storage errors */ }
        // Redirect to /login with a kicked flag; Login.jsx renders the toast on mount.
        setTimeout(() => {
          window.location.href = "/login?kicked=1";
        }, 200);
      }
    }
    return Promise.reject(err);
  }
);

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Request failed";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return JSON.stringify(d);
}
